// extracted by mini-css-extract-plugin
module.exports = {"component":"card-base-image_component__Rrttf","loader":"card-base-image_loader__Zi3u3"};